export enum ReminderType {
    Order = 0,
    Invoice = 1,
}

export enum EPushNotificationReminderType {
  AnnualFee = 0,
  Onboarding = 1,
}
